// The University of Wyoming's undergraduate majors (#2840). Read on
// 2026-10-01 from the official 2026-2027 University of Wyoming Catalog
// (acalogcatalog.uwyo.edu, catoid=19): each college's or school's catalog
// page lists its undergraduate degrees, and each group cites that page.
// Checked against the catalog's Academic Degree Programs list (navoid=1924).
// Left out: options and concentrations, the concurrent-only majors (Applied
// Computing, Honors Interdisciplinary Inquiry), dual degrees (Physiology
// B.S./Pharm.D., Political Science B.A./M.A.), minors, certificates, and the
// UW at Casper page, whose degrees repeat Laramie majors. "(online)" and
// "(hybrid)" delivery tags are dropped from names. Engineering degrees are
// written "Bachelor of Science in X" in the catalog and appear here as X,
// B.S. The degree-programs list also names "Electrical Engineering, F.M. Long
// Bioengineering, B.S."; the college page does not list it, so it is left
// out. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-wyoming",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UW's official 2026-2027 Catalog, grouped by the college or school that lists it, with the degree it leads to. Options, concentrations, concurrent-only majors, dual degrees, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture, Life Sciences, and Natural Resources",
            "source": {
                "label": "UW 2026-2027 Catalog, College of Agriculture, Life Sciences, and Natural Resources",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3037"
            },
            "majors": [
                {
                    "name": "Agricultural Business",
                    "degree": "B.S."
                },
                {
                    "name": "Agricultural Communications",
                    "degree": "B.S."
                },
                {
                    "name": "Animal and Veterinary Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Botany",
                    "degree": "B.S."
                },
                {
                    "name": "Design, Merchandising and Textiles",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development and Family Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Human Nutrition and Food",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Physiology",
                    "degree": "B.S."
                },
                {
                    "name": "Plant Production and Protection",
                    "degree": "B.S."
                },
                {
                    "name": "Ranch Management & Agricultural Leadership",
                    "degree": "B.S."
                },
                {
                    "name": "Rangeland Ecology and Watershed Management",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife and Fisheries Biology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Zoology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Arts & Sciences",
            "source": {
                "label": "UW 2026-2027 Catalog, College of Arts & Sciences",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3044"
            },
            "majors": [
                {
                    "name": "Communication",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art Education",
                    "degree": "B.A."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice and Criminology",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "European Languages, Literature and Film Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Native American and Indigenous Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre and Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre and Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Visual Communication Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "UW 2026-2027 Catalog, College of Business",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3063"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.S.B."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.E."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UW 2026-2027 Catalog, College of Education",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3067"
            },
            "majors": [
                {
                    "name": "Secondary Education, Agricultural Education",
                    "degree": "B.S."
                },
                {
                    "name": "Career and Technical Education",
                    "degree": "B.A.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education/Special Education",
                    "degree": "B.A."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.A.",
                    "note": "Taken with a concurrent major in the subject you will teach."
                }
            ]
        },
        {
            "name": "College of Engineering and Physical Sciences",
            "source": {
                "label": "UW 2026-2027 Catalog, College of Engineering and Physical Sciences",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3070"
            },
            "majors": [
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Geology and Geohydrology",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Health Sciences",
            "source": {
                "label": "UW 2026-2027 Catalog, College of Health Sciences",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3077"
            },
            "majors": [
                {
                    "name": "Kinesiology and Health Promotion",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Education Teaching (K-12)",
                    "degree": "B.S."
                },
                {
                    "name": "Speech, Language and Hearing Science",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                },
                {
                    "name": "Dental Hygiene",
                    "degree": "B.S.D.H."
                }
            ]
        },
        {
            "name": "Haub School of Environment and Natural Resources",
            "source": {
                "label": "UW 2026-2027 Catalog, Haub School of Environment and Natural Resources",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3090"
            },
            "majors": [
                {
                    "name": "Environment & Natural Resources",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Systems Science",
                    "degree": "B.S."
                },
                {
                    "name": "Outdoor Recreation & Tourism Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Energy Resources",
            "source": {
                "label": "UW 2026-2027 Catalog, School of Energy Resources",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3094"
            },
            "majors": [
                {
                    "name": "Energy Resource Management and Development",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Computing",
            "source": {
                "label": "UW 2026-2027 Catalog, School of Computing",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3161"
            },
            "majors": [
                {
                    "name": "Applied Software Development",
                    "degree": "B.S."
                },
                {
                    "name": "Geospatial Information Science and Technology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Bachelor of General Studies",
            "source": {
                "label": "UW 2026-2027 Catalog, Bachelor of General Studies",
                "url": "https://acalogcatalog.uwyo.edu/preview_entity.php?catoid=19&ent_oid=3169"
            },
            "majors": [
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                }
            ]
        }
    ]
};

export default majors;
